
import {initActions} from '@dized/ui/dist/redux/ActionHelper';
import {genericActions} from '@dized/ui/dist/redux/OrmHelper';
import {filterByGameId, generateFilter} from '@dized/ui/dist/redux/FilterHelper';
import {patch, post, get} from '@dized/ui/dist/redux/RequestHelper';

const filterByType = (game, type, category) => game && type ? generateFilter({game, type, category}) : undefined;

const apiPath = '/api/v1/project/projects';
const modelName = 'PROJECT';

export default initActions('ProjectActions', {
  ...genericActions({modelName}, apiPath),
  GET_PROJECT: (uuid, type, category) => get(apiPath, filterByType(uuid, type, category)),
  GET_PROJECTS: uuid => get(apiPath, filterByGameId(uuid)),
  PATCH_PROJECT: params => patch(apiPath, params),
  POST_PROJECT: params => post(apiPath, params),
});
